import { Link } from "react-router-dom";
import BlockShell from "./BlockShell";
import { absUrl } from "./media";

const SponsorsBlock = ({ block }) => {
  const cfg = block.config || {};
  const sponsors = cfg.sponsors || [];
  const badge = cfg.style === "badges" || sponsors.some((s) => s.url && !/^https?:/i.test(s.url));
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-8" data-testid="fest-sponsors">
      <BlockShell block={block}>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {sponsors.map((s, i) => {
            const inner = (
              <div className={`bg-white rounded-xl border border-[#E2E0DC] p-3 flex flex-col items-center justify-center gap-2 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-[box-shadow,transform] ${badge ? "min-h-40" : "h-24"}`} data-testid={`sponsor-badge-${i}`}>
                {s.logo ? (
                  <img src={absUrl(s.logo)} alt={s.name} loading="lazy" className={`${badge ? (s.wide ? "h-16 w-auto max-w-[9rem] rounded-lg object-contain bg-white border border-[#E2E0DC]" : "h-16 w-16 rounded-full object-contain bg-white p-0.5 border border-[#E2E0DC]") : "max-h-16 max-w-full object-contain"}`} />
                ) : (
                  <span className="text-sm font-semibold text-[#1A1A1A]">{s.name}</span>
                )}
                {badge && s.logo && (
                  <span className="text-center leading-tight">
                    <span className="block text-[11px] font-extrabold tracking-wide text-[#1A1A1A]">{s.name.split(" · ")[0]}</span>
                    {s.name.includes(" · ") && <span className="block mt-0.5 text-[13px] font-semibold text-[#2E5C55]" data-testid={`sponsor-sub-${i}`}>{s.name.split(" · ").slice(1).join(" · ")}</span>}
                  </span>
                )}
              </div>
            );
            if (!s.url) return <div key={i}>{inner}</div>;
            return /^https?:/i.test(s.url)
              ? <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" className="no-underline">{inner}</a>
              : <Link key={i} to={s.url} className="no-underline">{inner}</Link>;
          })}
          {sponsors.length === 0 && (
            <p className="text-sm italic text-[#5C5C5C] col-span-full">No sponsors added yet.</p>
          )}
        </div>
      </BlockShell>
    </section>
  );
};

export default SponsorsBlock;
